import React from 'react'

import { Link } from 'react-router-dom'
import { AppBar, Toolbar, Box } from '@material-ui/core'
import clsx from 'clsx'
import { isEmpty } from 'lodash'

import { EndDate } from './components'

import useAuthSupplier from 'hooks/useAuthSupplier'
import useCustomTheme from 'hooks/useCustomTheme'

import useStyles from './styles'

const TopBar = () => {
  const auth = useAuthSupplier()
  const classes = useStyles()
  const { customLogo } = useCustomTheme()

  return (
    <AppBar elevation={0} className={clsx(classes.root)}>
      <Toolbar>
        {!isEmpty(customLogo) && (
          <Box>
            <Link to={auth.homeRoute}>
              <img
                alt="Logo"
                src={customLogo}
                className={classes.logo}
                onError={(e) => {
                  e.target.style.display = 'none'
                }}
              />
            </Link>
          </Box>
        )}
        <Box ml={1} flexGrow={1} />
        <Box ml={1}>
          <EndDate />
        </Box>
      </Toolbar>
    </AppBar>
  )
}

export default TopBar
